import React__default from 'react';

var usePagination = function usePagination(initialPageIndex, initialPageSize) {
  if (initialPageIndex === void 0) {
    initialPageIndex = 0;
  }

  if (initialPageSize === void 0) {
    initialPageSize = 10;
  }

  var _React$useState = React__default.useState(initialPageIndex),
      pageIndex = _React$useState[0],
      setPageIndex = _React$useState[1];

  var _React$useState2 = React__default.useState(initialPageSize),
      pageSize = _React$useState2[0],
      setPageSize = _React$useState2[1];

  return {
    pageIndex: pageIndex,
    pageSize: pageSize,
    setPageIndex: setPageIndex,
    setPageSize: setPageSize
  };
};

export { usePagination };
//# sourceMappingURL=usePagination.js.map
